import React, { FC } from "react";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import { useField } from "formik";
import { IFormField } from "src/@types/form";
import { FormField } from ".";
import { TextEditor } from "../TextEditor";

export const EditorField: FC<IFormField> = ({
  className,
  fieldClassName,
  labelClassName,
  id,
  label,
  placeholder,
  errorClassName,
  name,
}) => {
  const { t } = useTranslation();

  const fieldId = id || (name as string);

  const [fieldProps, fieldMeta, fieldHelpers] = useField(fieldId);

  const { value } = fieldProps;
  const { error, touched } = fieldMeta;
  const { setValue } = fieldHelpers;

  const isShownError = Boolean((touched || value) && error);

  const placeholderText =
    typeof placeholder === "string"
      ? placeholder
      : placeholder && t(placeholder.i18nKey, placeholder.i18nParams);

  return (
    <FormField
      className={fieldClassName}
      labelClassName={labelClassName}
      label={label}
      labelFor={fieldId}
      isShownError={isShownError}
      error={error}
      errorClassName={errorClassName}
    >
      <TextEditor
        value={value}
        onChange={setValue}
        placeholder={placeholderText}
        className={className}
      />
    </FormField>
  );
};
